// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"45e41d95","198":"4d87a144","453":"99a88109"}[chunkId] + ".chunk.js";
};